import { FRAUD_TYPE } from '../constants';
import {
  FraudConfigBase,
  FraudEmulatorBotsConfig,
  FraudEventCapping,
  FraudEventClickCappingConfig,
  FraudIpClickCappingConfig,
  FraudReferrerConfig,
  FraudRequiredUrlParameters,
  FraudVpnProxyConfig,
} from './../models/fraud-config.model';

export const isValidationUrlParametersOnInApp = (
  fraudBase: FraudConfigBase
): fraudBase is FraudRequiredUrlParameters => {
  return fraudBase.type === FRAUD_TYPE.URL_PARAMETERS_VALIDATION_INAPP;
};

export const isValidationUrlParametersOnClicks = (
  fraudBase: FraudConfigBase
): fraudBase is FraudRequiredUrlParameters => {
  return fraudBase.type === FRAUD_TYPE.URL_PARAMETERS_VALIDATION_CLICK;
};

export const isBlockingUrlParametersOnInApp = (
  fraudBase: FraudConfigBase
): fraudBase is FraudRequiredUrlParameters => {
  return fraudBase.type === FRAUD_TYPE.URL_PARAMETERS_BLOCKING_INAPP;
};

export const isBlockingUrlParametersOnClicks = (
  fraudBase: FraudConfigBase
): fraudBase is FraudRequiredUrlParameters => {
  return fraudBase.type === FRAUD_TYPE.URL_PARAMETERS_BLOCKING_CLICK;
};

export const isIpClickCapping = (fraudBase: FraudConfigBase): fraudBase is FraudIpClickCappingConfig => {
  return fraudBase.type === FRAUD_TYPE.IP_CLICK_CAPPING;
};

export const isEventCapping = (fraudBase: FraudConfigBase): fraudBase is FraudEventCapping => {
  return fraudBase.type === FRAUD_TYPE.EVENT_CAPPING;
};

export const isVpnProxyOnInApp = (fraudBase: FraudConfigBase): fraudBase is FraudVpnProxyConfig => {
  return fraudBase.type === FRAUD_TYPE.VPN_PROXY_IP_INAPP;
};

export const isVpnProxyOnClicks = (fraudBase: FraudConfigBase): fraudBase is FraudVpnProxyConfig => {
  return fraudBase.type === FRAUD_TYPE.VPN_PROXY_IP_CLICK;
};

export const isEventClickCapping = (
  fraudBase: FraudConfigBase
): fraudBase is FraudEventClickCappingConfig => {
  return fraudBase.type === FRAUD_TYPE.EVENT_CLICK_CAPPING;
};

export const isEventFlowCapping = (fraudBase: FraudConfigBase): fraudBase is FraudEventClickCappingConfig => {
  return fraudBase.type === FRAUD_TYPE.EVENT_FLOW_CAPPING;
};

export const isRefererRule = (fraudBase: FraudConfigBase): fraudBase is FraudReferrerConfig => {
  return fraudBase.type === FRAUD_TYPE.INVALID_REFERRER;
};

export const isEmulatorBots = (fraudBase: FraudConfigBase): fraudBase is FraudEmulatorBotsConfig => {
  return fraudBase.type === FRAUD_TYPE.EMULATOR_BOTS;
};
